var ssrLoaderData = /* @__PURE__ */ new WeakMap();
function setSSRLoaderData(loaderFn, data) {
  ssrLoaderData.set(loaderFn, data);
}
export {
  setSSRLoaderData,
  ssrLoaderData
};
//# sourceMappingURL=ssrLoaderData.js.map
